import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { MenuIcon, SearchIcon, ShoppingBagIcon, UserIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { useCart } from '../contexts/CartContext';
const LINKS = [{
  label: 'Inicio',
  to: '/'
}, {
  label: 'Productos',
  to: '/productos'
}, {
  label: 'Nosotros',
  to: '/#nosotros'
}, {
  label: 'Contacto',
  to: '/#contacto'
}];
export function Navbar() {
  const [open, setOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [query, setQuery] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const {
    count
  } = useCart();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (searchOpen) inputRef.current?.focus();
  }, [searchOpen]);
  const isActive = (to: string) => to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);
  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(query.trim() ? `/productos?q=${encodeURIComponent(query.trim())}` : '/productos');
    setSearchOpen(false);
  };
  return <header className="sticky top-0 z-50 w-full border-b border-white/10 bg-black/85 backdrop-blur-md" data-id="element-643" data-mp="jmnklz2fshu9">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between gap-4 px-5 sm:h-20 lg:px-8" data-id="element-644" data-mp="olgor0vu2whr">
        <Logo data-id="element-645" data-mp="3n3vy66q4svj6" />

        <nav aria-label="Navegación principal" className="hidden items-center gap-9 md:flex" data-id="element-646" data-mp="3n4f74xxt09l2">
          {LINKS.map(link => link.to.includes('#') ? <Link key={link.label} to={link.to} className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white/60 transition-colors hover:text-white" data-id="element-647" data-mp="v4idug8l7ta">
                {link.label}
              </Link> : <NavLink key={link.label} to={link.to} className={`relative text-[11px] font-semibold uppercase tracking-[0.18em] transition-colors hover:text-white ${isActive(link.to) ? 'text-white' : 'text-white/60'}`} data-id="element-648" data-mp="39axp5hkrn4x5">
                {link.label}
                {isActive(link.to) && <span className="absolute -bottom-2 left-0 h-[2px] w-full bg-pink-500" data-id="element-649" data-mp="361q8o3tuurpx" />}
              </NavLink>)}
        </nav>

        <div className="flex items-center gap-1 sm:gap-2" data-id="element-650" data-mp="2ddc9hkr15pcs">
          <button type="button" onClick={() => setSearchOpen(v => !v)} aria-label={searchOpen ? 'Cerrar buscador' : 'Abrir buscador'} aria-expanded={searchOpen} className={`flex h-10 w-10 items-center justify-center rounded-full transition-colors hover:bg-white/5 ${searchOpen ? 'text-pink-500' : 'text-white/70 hover:text-white'}`} data-id="element-651" data-mp="2devqxeofa6g5">
            {searchOpen ? <XIcon className="h-[18px] w-[18px]" data-id="element-652" data-mp="a4ixcsgvpwcn" /> : <SearchIcon className="h-[18px] w-[18px]" data-id="element-653" data-mp="f3vldgjhl9gt" />}
          </button>
          <Link to="/login" aria-label="Ingresar a mi cuenta" className="flex h-10 w-10 items-center justify-center rounded-full text-white/70 transition-colors hover:bg-white/5 hover:text-white" data-id="element-654" data-mp="f1itobnxfkqk">
            <UserIcon className="h-[18px] w-[18px]" data-id="element-655" data-mp="swbf1qqhzv52" />
          </Link>
          <Link to="/carrito" aria-label={`Carrito, ${count} productos`} className="relative flex h-10 w-10 items-center justify-center rounded-full text-white transition-colors hover:bg-white/5" data-id="element-656" data-mp="xu3ini0i95p3">
            <ShoppingBagIcon className="h-[18px] w-[18px]" data-id="element-657" data-mp="o38ta4ryppzf" />
            {count > 0 && <span className="absolute -right-0.5 -top-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-pink-500 px-1 text-[10px] font-bold text-white" data-id="element-658" data-mp="1bt346gsq14h1">
                {count}
              </span>}
          </Link>
          <button type="button" onClick={() => setOpen(v => !v)} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={open} className="flex h-10 w-10 items-center justify-center rounded-full text-white transition-colors hover:bg-white/5 md:hidden" data-id="element-659" data-mp="3k2u8jmeb8o2q">
            {open ? <XIcon className="h-5 w-5" data-id="element-660" data-mp="blzemwfhqe0s" /> : <MenuIcon className="h-5 w-5" data-id="element-661" data-mp="bm99axbhd9ct" />}
          </button>
        </div>
      </div>

      {searchOpen && <div className="border-t border-white/10 bg-black" data-id="element-662" data-mp="6qabkj49iezq">
          <form onSubmit={submitSearch} role="search" className="mx-auto flex w-full max-w-7xl items-center gap-3 px-5 py-4 lg:px-8" data-id="element-663" data-mp="1vwmszk3v641">
            <SearchIcon className="h-4 w-4 shrink-0 text-white/35" data-id="element-664" data-mp="udsaqzpuwfcq" />
            <input ref={inputRef} type="search" value={query} onChange={e => setQuery(e.target.value)} placeholder="Buscar bandas, guantes, tobilleras..." aria-label="Buscar productos" className="w-full bg-transparent py-1 text-sm text-white placeholder:text-white/30 focus:outline-none" data-id="element-665" data-mp="pmtm9cupsaye" />
            <button type="submit" className="bg-pink-500 px-5 py-2.5 text-[10px] font-bold uppercase tracking-[0.16em] text-white transition-colors hover:bg-pink-600" data-id="element-666" data-mp="2m9303ytmwivv">
              Buscar
            </button>
          </form>
        </div>}

      {open && <nav aria-label="Navegación móvil" className="border-t border-white/10 bg-black px-5 py-4 md:hidden" data-id="element-667" data-mp="30yh6qz5tsm7k">
          <ul className="flex flex-col" data-id="element-668" data-mp="34zay62ih8j57">
            {LINKS.map(link => <li key={link.label} data-id="element-669" data-mp="39zyn8in5apws">
                <Link to={link.to} onClick={() => setOpen(false)} className="block border-b border-white/5 py-3 font-display text-xl uppercase tracking-wider text-white/80" data-id="element-670" data-mp="3a0qgvnx6mdkf">
                  {link.label}
                </Link>
              </li>)}
            <li data-id="element-671" data-mp="1olaeejdiycj4">
              <Link to="/mis-pedidos" onClick={() => setOpen(false)} className="block py-3 font-display text-xl uppercase tracking-wider text-pink-500" data-id="element-672" data-mp="1om27nnjnfy68">
                Mi cuenta
              </Link>
            </li>
          </ul>
        </nav>}
    </header>;
}